// Reliable WhatsApp opener that breaks out of the preview iframe.
// Uses a temporary anchor with target="_blank" + rel="noopener,noreferrer"
// instead of window.open() (which is sometimes blocked by sandboxed iframes
// or forced to redirect to api.whatsapp.com inside the current frame).
import { CLINIC, doctorDisplay } from "./clinic";
import api from "./api";

// Fire-and-forget outbound log — keeps a complete WhatsApp history in the
// backend from day one so future BSP automation (AiSensy/Gupshup) inherits it.
function _logOutbound(url, kind) {
  try {
    const u = new URL(url);
    const to = u.pathname.replace(/\D/g, "");
    const preview = decodeURIComponent(u.searchParams.get("text") || "").slice(0, 160);
    api.post("/wa/log", { to, preview, kind: kind || "manual_share" }).catch(() => {});
  } catch { /* never block the share */ }
}

// Short professional signature appended to every outgoing WhatsApp message.
// Skipped when the message already carries the full branded block (the
// "━━━" separator used by buildWhatsAppBrandedMessage).
export function withSignature(message) {
  const msg = String(message || "");
  if (msg.includes("━━━")) return msg;
  const phone = (CLINIC.phones || [])[0] || "";
  const sig =
    `\n\n— *${doctorDisplay(CLINIC.doctorName)}*` +
    `\n${CLINIC.specialties || ""}` +
    `\n🏥 ${CLINIC.short || CLINIC.name} · 🕐 ${CLINIC.timings || ""}` +
    (phone ? `\n📞 ${phone}` : "");
  return msg + sig;
}

export function buildWaUrl(mobile, message) {
  const digits = String(mobile || "").replace(/\D/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(message || "")}`;
}

// Open WhatsApp WITHOUT the doctor signature — for patient-initiated or
// staff-to-partner chats where a clinical sign-off would be out of place.
export function openWhatsAppRaw(mobile, message) {
  return _openUrl(buildWaUrl(mobile, message));
}

export function openWhatsApp(mobile, message, kind) {
  return _openUrl(buildWaUrl(mobile, withSignature(message)), kind);
}

function _openUrl(url, kind) {
  _logOutbound(url, kind);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (_) {
    // Last-resort fallback
    window.open(url, "_blank", "noopener,noreferrer");
  }
  return url;
}
